import classNames from "classnames";
import React, { PureComponent } from "react";

import { ITestable, testAttr } from "@/browser";

import { Icon } from "../Icon";
import { TMessageType } from "./MessagesContext";

export interface IMessageProps extends ITestable {
  /**
   * Extend component classes
   * @default undefined
   */
  className?: string;

  /**
   * Extend component classes
   * @default "close"
   */
  closeIcon?: string;

  /**
   * Title of a message
   * @default undefined
   */
  title?: string;

  /**
   * Text of a message
   * @default undefined
   */
  text?: string;

  /**
   * Component of a message
   */
  component?: React.ReactNode;

  /** Type of message   `information`, `attention`,  `success`,  `warning` */
  type?: TMessageType;

  /**
   * Function called when message clicked
   * @default undefined
   * @param {React.MouseEvent<any>} event
   */
  onClose?: (event: React.MouseEvent<any>) => void;

  onMouseLeave?: (event: React.MouseEvent<any>) => void;

  onMouseEnter?: (event: React.MouseEvent<any>) => void;
}

class Message extends PureComponent<IMessageProps> {
  static defaultProps: Partial<IMessageProps> = {
    type: "information",
    closeIcon: "close",
  };

  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    const { onClose } = this.props;

    if (onClose) {
      onClose(event);
    }
  };

  renderContent = (render?: IMessageProps["text"] | IMessageProps["component"]) => {
    return !!render && <div className="el-message-content">{render}</div>;
  };

  render() {
    const { closeIcon, component, children, title, text, onClose, onMouseEnter, onMouseLeave, type } = this.props;
    const classes = classNames("el-message", `el-message--theme-${type}`);
    const testable = testAttr(this.props, { sufix: "message" });

    return (
      <div {...testable} className={classes} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div className="el-message__text-container">
          {title && <div className="el-message-title">{title}</div>}
          {this.renderContent(text || component || children)}
        </div>

        {onClose && (
          <div className="el-message__actions-container">
            <a onClick={this.handleClick} className="el-message-action">
              <Icon className="el-message-action-icon" icon={closeIcon as string} size="md" />
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default Message;
